<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    ...mapState({
      token: "token",
    }),
  },
  watch:{},
  created() {
    try {
      let localToken = JSON.parse(localStorage.getItem("token"));
      this.set_token(localToken);
    } catch (error) {
      console.info("用户未登录");
    }
  },
  methods: {
    ...mapActions({
      set_token: "set_token",
    }),
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/App.vue